import { render, staticRenderFns } from "./LoggedCallsTable.vue?vue&type=template&id=55942a0d"
import script from "./LoggedCallsTable.vue?vue&type=script&lang=js"
export * from "./LoggedCallsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports